<template>
	<div class="flex flex-col w-dvw min-h-(--min-height-custom-mobile) lg:min-h-(--min-height-custom) items-center justify-center pt-8 pb-20">
		<!-- Our Story Paragraphs -->
		<div class="flex flex-col items-center gap-4 w-7/8 lg:w-3/5 text-center">
			<span class="text-6xl lg:text-8xl tracking-wider lg:tracking-widest font-(family-name:--sloop-script)! mb-8">Our Story</span>
			<span>
				Our story begins with two very young and very single people wanting
				to go out for Valentine’s Day.
			</span>
			<span>
				It is February 2021 in Clemson, South Carolina. COVID-19 almost a year
				old and the safety regulations are starting to dissipate. Brennan is
				recently single and had just attended her sister’s wedding so she is
				having a hard time in the love department. Grant just celebrated his
				20th birthday and yet another year being single. Grant’s fraternity
				is planning to throw a Valentine’s Day party on February 13th, and
				Grant’s plan was to attend alone.
			</span>
			<span>
				Coincidentally, Brennan’s close friend Josh is also in the same fraternity
				and her freshman year roommate and close friend Melanie will also be
				attending the function. Thus the plot thickens as Melanie and Josh
				hunt to find Brennan a date so she can have fun with her friends.
				Her only requests were the suggested date would be fun and that
				he would not be creepy to her. Melanie and Josh go to work looking
				through the boys of the fraternity and come back with a few people
				they think could be good, but are highly fond of one of the boy’s
				named “G”. After doing some Instagram stalking and talking to her
				brother to see if this “G’ is cool, Josh talks to G who says he
				does not have a date and would love to take her, and Melanie tells
				Brennan they can go together, if she agrees. She does.
			</span>
			<span>
				The big day arrives and Brennan arrives with Melanie for the party
				before the party nervous but excited. G and his friends are playing
				games, but G is sitting in the corner, naturally the farthest point
				from the door and they do not talk for a while. Brennan and her
				friends join in on the games, and at some point, a big group goes
				outside, leaving Brennan and Grant alone....
			</span>
			<span>
				After some awkward introductions, learning his name is Grant (not G),
				and learning they both work at the on-campus gym, the nervousness
				subsides. They spend the rest of the night talking, laughing, and
				dancing. Some may say they were inseparable...
			</span>
			<span>
				The next morning, they both want to reach out but are not quite sure
				how. Brennan finally sends the pictures from the night before and
				making a joke about how Grant spilled wine on his shirt. The rest,
				as they say, was history. They started dating on May 29, 2021 as
				months of talking, hanging out, and getting to know each other.
			</span>
			<span>
				After 6 years, 2.5 years of long distance dating, the pair living
				in a collective 5 different states, and finally moving in together
				in their New York City apartment, Brennan and Grant are tying the
				knot on their 6th anniversary.
			</span>
		</div>
	</div>
</template>

<script setup lang="ts">
	import LoadingCard from "~/components/LoadingCard.vue";
	import Divider from "primevue/divider";
	import {
		useCssVar,
		useDateFormat
	} from "@vueuse/core";

	const dateFormatString: string = "MMMM D, YYYY";
	const verticalDividerContentPadding = useCssVar( "--p-divider-vertical-content-padding" );

	const { contentLoaded, ourStoryPhotos } = imageDataStores();
	const { MAX_DESKTOP_WIDTH, ALLOW_API_CALLS } = globalStores();
	const { width } = useWindowSize();

	const initializePage = () => {
		verticalDividerContentPadding.value = "0";
	};

	initializePage();
</script>

<style scoped>

</style>